// TINYMCE OPTIONS VARIABLES
import CompressImageService from '@/services/ImageProcessorService';

const OPTIONS = {
  height: 'calc(100vh - 169px)',
  force_p_newlines: true,
  plugins: ['noneditable', 'save', 'textcolor', 'preventdelete',
    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
    'searchreplace wordcount visualblocks visualchars code fullscreen',
    'insertdatetime media nonbreaking save table contextmenu directionality',
    'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample',
    'image imagetools',
    'pagebreak'],
  toolbar: 'formatselect | bold italic  strikethrough  forecolor backcolor | fontselect fontsizeselect | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | code | pagebreak | image',
  fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
  content_style: 'html { background: #F6F7F9 } ' +
    'body {width: 210mm; min-height: 297mm; padding: 20mm; background: white; margin: 10px auto; box-shadow: 0px 4px 10px #aaa}' +
    'figure.image {display: inline-block;}' +
    'figure img:after {content: "a"; background: red;}' +
    'figure.align-left {float: left;}' +
    'figure.align-center {display: block !important;}' +
    'figure.align-center > img {margin: 0 auto; display: block}' +
    'figure.align-right {float: right;}' +
    'figure.image figcaption {display: block; margin: 6px 8px 6px 8px;text-align: center;}',
  pagebreak_separator: '<p style="page-break-before: always;"><!-- pagebreak --></p>',
  imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptionsm',
  paste_data_images: true,
  automatic_uploads: true,
  file_picker_types: 'image',
  image_caption: true,
  image_description: false,
  extended_valid_elements:"style,link[href|rel]",
  custom_elements:"style,link,~link",
  file_picker_callback: (cb) => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');

    /*
      Note: In modern browsers input[type="file"] is functional without
      even adding it to the DOM, but that might not be the case in some older
      or quirky browsers like IE, so you might want to add it to the DOM
      just in case, and visually hide it. And do not forget do remove it
      once you do not need it anymore.
    */

    input.onchange = function () { // eslint-disable-line
      const file = this.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        const id = `blobid${(new Date()).getTime()}`;
        const blobCache = tinymce.activeEditor.editorUpload.blobCache;
        CompressImageService.compressImage(reader.result, 1024, 768, (base64Payload) => {
          const blobInfo = blobCache.create(id, file, base64Payload);
          blobCache.add(blobInfo);
          cb(blobInfo.blobUri(), { title: file.name });
        });
        /* call the callback and populate the Title field with the file name */
      };
      reader.readAsDataURL(file);
    };

    input.click();
  },
  language_url: 'https://dyonir.github.io/vue-tinymce-editor/static/langs/pt_BR.js',
};

const TINYMCE_OPTIONS = () => {
  return OPTIONS
};

export default TINYMCE_OPTIONS;



// WEBPACK FOOTER //
// ./src/constants/TINYMCE_OPTIONS.js